export default __webpack_public_path__ + "static/media/white-up-pointing-index.574c7441.png";